<template>
  <div class="h-100">
    <slot name="sidebar-left-medium"></slot>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'

export default {
  name: "SidebarLeftMedium",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>

</style>
